import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductFinanceWizard = lazy(() => import(/* webpackChunkName: "ProductFinanceWizard" */ './components/ProductFinanceWizard'));

const productFinanceWizard = document.getElementById('product-finance-wizard');
if (productFinanceWizard != null) {
    const props = parseDatasetToProps(productFinanceWizard.dataset);

    render(
        <Suspense fallback={<></>}>
            <ProductFinanceWizard
                {...props}
            />
        </Suspense>,
        productFinanceWizard
    );
}
